import { Component, OnDestroy, ViewEncapsulation, OnInit } from '@angular/core';
import { PcMediaWatcherService } from 'app/shared/services/media-watcher';
import { UserService } from 'app/core/user/user.service';
import { User } from 'app/core/user/user.types';

import { RouterModule } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'empty-selector-layout',
  templateUrl: './empty-selector.component.html',
  encapsulation: ViewEncapsulation.None,
  imports: [RouterModule],
})
export class EmptySelectorLayoutComponent implements OnDestroy, OnInit {
  isScreenSmall: boolean;
  user: User;
  private _unsubscribeAll: Subject<any> = new Subject<any>();
  logo: any;

  /**
   * Constructor
   */
  constructor(
    private _userService: UserService,
    private _pcMediaWatcherService: PcMediaWatcherService
  ) {
    const preference = sessionStorage.getItem('primecontrol_preference')
      ? sessionStorage.getItem('primecontrol_preference')
      : localStorage.getItem('primecontrol_preference');

    const { horizontal_logo, square_logo } = JSON.parse(preference);
    this.logo = horizontal_logo ? horizontal_logo : square_logo;
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    // Subscribe to the user service
    this.user = JSON.parse(this._userService.user$);

    // Subscribe to media changes
    this._pcMediaWatcherService.onMediaChange$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(({ matchingAliases }) => {
        // Check if the screen is small
        this.isScreenSmall = !matchingAliases.includes('md');
      });
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }
}
